// import { type } from "@testing-library/user-event/dist/type";

export function calculateBasicPrice(headsets) {
  switch (true) {
    case headsets >= 0 && headsets <= 10:
      return 125;
    case headsets >= 11 && headsets <= 15:
      return 135;
    case headsets >= 16 && headsets <= 25:
      return 140;
    case headsets >= 26 && headsets <= 30:
      return 160;
    case headsets >= 31 && headsets <= 50:
      return 175;
    case headsets >= 51 && headsets <= 60:
      return 190;
    case headsets >= 61 && headsets <= 75:
      return 225;
    case headsets >= 76 && headsets <= 100:
      return 250;
    case headsets >= 101 && headsets <= 125:
      return 320;
    case headsets >= 126 && headsets <= 150:
      return 350;
    case headsets >= 151 && headsets <= 200:
      return 420;
    case headsets >= 201 && headsets <= 250:
      return 520;
    case headsets >= 251 && headsets <= 300:
      return 675;
    case headsets >= 301 && headsets <= 350:
      return 825;
    case headsets >= 351 && headsets <= 400:
      return 895;
    case headsets >= 401 && headsets <= 450:
      return 995;
    case headsets >= 451 && headsets <= 500:
      return 1095;
    default:
      return 0;
  }
}

// export function calculateTotalPrice(basePrice, delivery = 0, extras = {}) {
//   const totalValue = Object.values(extras).reduce(
//     (accumulator, currentItem) => {
//       if (currentItem.price) {
//         return accumulator + currentItem.price;
//       } else {
//         return accumulator + currentItem.value;
//       }
//     },
//     0
//   );

//   return basePrice + delivery + totalValue;
// }

export function calculateTotalPrice(basePrice, delivery = 0, extras = {}) {
  const totalValue = Object.values(extras).reduce((accumulator, item) => {
    const value = Number(item.price ?? item.value ?? 0);
    return accumulator + (Number.isNaN(value) ? 0 : value);
  }, 0);

  return Number(basePrice || 0) + Number(delivery || 0) + totalValue;
}

async function isBankHoliday(date) {
  let isBankHoliday = false;

  // format date to yyyy-mm-dd
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-indexed
  const day = date.getDate().toString().padStart(2, "0");
  const testDate = `${year}-${month}-${day}`;

  try {
    const response = await fetch("https://www.gov.uk/bank-holidays.json");
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    const data = await response.json();

    data["england-and-wales"].events.forEach((holiday) => {
      const d = new Date(holiday.date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-indexed
      const day = d.getDate().toString().padStart(2, "0");

      if (`${year}-${month}-${day}` === testDate) {
        isBankHoliday = true;
        return true;
      }
    });
    return isBankHoliday;
  } catch (error) {
    console.error("Error fetching data:", error);
    return false;
  }
}

export async function calculateDeliveryDate(date) {
  let d = formatDisplayDate(date);
  const parts = d.split("/");
  const parsedDate = new Date(parts[2], parts[1] - 1, parts[0]); // Month is 0-based

  // Check the day of the week
  const dayOfWeek = parsedDate.getDay();

  // Apply conditions based on the day of the week
  if (dayOfWeek === 1) {
    // If Monday, remove 3 days
    parsedDate.setDate(parsedDate.getDate() - 3);
  } else if (dayOfWeek === 0) {
    // If Sunday, remove 2 days
    parsedDate.setDate(parsedDate.getDate() - 2);
  } else {
    // For other days, remove 1 day
    parsedDate.setDate(parsedDate.getDate() - 1);
  }

  // Check if bank holiday
  if (await isBankHoliday(parsedDate)) {
    const BHdayOfWeek = parsedDate.getDay();
    // Apply conditions based on the day of the week
    if (BHdayOfWeek === 1) {
      // If Monday, remove 3 days
      parsedDate.setDate(parsedDate.getDate() - 3);
    } else if (BHdayOfWeek === 0) {
      // If Sunday, remove 2 days
      parsedDate.setDate(parsedDate.getDate() - 2);
    }
  }

  // Format the result as "dd/mm/yyyy"
  const transformedDate = `${parsedDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${(parsedDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${parsedDate.getFullYear()}`;

  return transformedDate;
}

export async function calculateAltDeliveryDate(date) {
  let d = formatDisplayDate(date);
  const parts = d.split("/");
  const parsedDate = new Date(parts[2], parts[1] - 1, parts[0] - 1); // Month is 0-based

  // Check the day of the week
  const dayOfWeek = parsedDate.getDay();

  // Apply conditions based on the day of the week
  if (dayOfWeek === 0) {
    // If Sunday, remove 2 days
    parsedDate.setDate(parsedDate.getDate() - 2);
  } else {
    // For other days, remove 1 day
    parsedDate.setDate(parsedDate.getDate());
  }

  // Check if bank holiday
  if (await isBankHoliday(parsedDate)) {
    const BHdayOfWeek = parsedDate.getDay();
    // Apply conditions based on the day of the week
    if (BHdayOfWeek === 1) {
      // If Monday, remove 3 days
      parsedDate.setDate(parsedDate.getDate() - 3);
    } else if (BHdayOfWeek === 0) {
      // If Sunday, remove 2 days
      parsedDate.setDate(parsedDate.getDate() - 2);
    }
  }

  // Format the result as "dd/mm/yyyy"
  const transformedDate = `${parsedDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${(parsedDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${parsedDate.getFullYear()}`;

  return transformedDate;
}

export async function calculateCollectionDate(date) {
  let d = formatDisplayDate(date);

  const parts = d.split("/");
  const parsedDate = new Date(parts[2], parts[1] - 1, parts[0]); // Month is 0-based
  // Check the day of the week
  const dayOfWeek = parsedDate.getDay();

  // Apply conditions based on the day of the week
  if (dayOfWeek === 5) {
    // If Monday, remove 3 days
    parsedDate.setDate(parsedDate.getDate() + 3);
  } else if (dayOfWeek === 6) {
    // If Sunday, remove 2 days
    parsedDate.setDate(parsedDate.getDate() + 2);
  } else {
    // For other days, remove 1 day
    parsedDate.setDate(parsedDate.getDate() + 1);
  }

  // Check if bank holiday
  if (await isBankHoliday(parsedDate)) {
    const BHdayOfWeek = parsedDate.getDay();
    // Apply conditions based on the day of the week
    if (BHdayOfWeek === 5) {
      // If Friday, add 3 days
      parsedDate.setDate(parsedDate.getDate() + 3);
    } else {
      // If Monday add 1 day
      parsedDate.setDate(parsedDate.getDate() + 1);
    }
  }

  // Format the result as "dd/mm/yyyy"
  const transformedDate = `${parsedDate
    .getDate()
    .toString()
    .padStart(2, "0")}/${(parsedDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${parsedDate.getFullYear()}`;

  return transformedDate;
}

// function getPreviousDate(startDate) {
//   // Parse the start date string to a Date object
//   if (typeof startDate !== "string") return startDate;

//   const parts = startDate.split("/");
//   const currentDate = new Date(parts[2], parts[1] - 1, parts[0]); // Month is 0-based

//   // Calculate the previous day's date
//   const previousDate = new Date(currentDate);
//   previousDate.setDate(currentDate.getDate() - 1);

//   // Format the result as "dd/mm/yyyy"
//   const formattedPreviousDate = `${previousDate
//     .getDate()
//     .toString()
//     .padStart(2, "0")}/${(previousDate.getMonth() + 1)
//     .toString()
//     .padStart(2, "0")}/${previousDate.getFullYear()}`;

//   return formattedPreviousDate;
// }

export function formatDate(timestamp) {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

export function isValidEmail(email) {
  if (email.includes("test.com") || email.includes("test.co.uk")) return false;

  // Regular expression for a simple email validation
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

  return emailRegex.test(email);
}

export function isValidName(name) {
  const str = name.trim();

  if (str.includes(" ")) return true;

  const words = str.split(" ").filter((word) => word.length > 0);

  return words.length >= 2;
}

export function getFormData(form) {
  const formData = {};
  const elements = form.elements;

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const { name, value } = element;

    if (name && value !== "") {
      formData[name] = value;
    }
  }

  return formData;
}

export function formatDisplayDate(date) {
  let d = date;
  if (typeof date === "string" && date.includes("-")) {
    const parts = date.split("-");
    const newDate = new Date(parts[0], parts[1] - 1, parts[2]);
    d = `${newDate.getDate().toString().padStart(2, "0")}/${(
      newDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${newDate.getFullYear()}`;
  }

  return d;
}

export function isWithin72Hours(dateString) {
  // Convert the dateString to a Date object
  const selectedDate = new Date(dateString);
  // Get the current time
  const currentTime = new Date();
  // Calculate the difference in milliseconds between the selected date and the current time
  const timeDiff = selectedDate.getTime() - currentTime.getTime();
  // Convert the time difference to hours
  const hoursDiff = Math.abs(timeDiff / (1000 * 60 * 60));
  // Check if the time difference is less than 72 hours
  return hoursDiff <= 72;
}

export function nonMainlandPostCode(postcode) {
  // Normalize the postcode to uppercase and trim any whitespace
  const normalizedPostcode = postcode.trim().toUpperCase();

  // Regular expression to match Northern Ireland postcodes (e.g., BT1, BT10, BT20, etc.)
  const niPostcodePattern = /^BT\d{1,2}\s?\d?[A-Z]{0,2}$/;

  // Test the normalized postcode against the pattern
  return niPostcodePattern.test(normalizedPostcode);
}

export function isDateInRange(startDateStr, endDateStr, targetDateStr) {
  // Convert date strings to Date objects
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  const targetDate = new Date(targetDateStr);
  // Check if targetDate is within the range
  return targetDate >= startDate && targetDate <= endDate;
}
